// extracted by mini-css-extract-plugin
export default {"wrapper":"EditPost_wrapper__cwf2X","contentEditable":"EditPost_contentEditable__MUxMy"};